import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcf2df18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img-contain" }
const _hoisted_2 = { class: "overlay" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "overlay-text" }, "I don't like this one", -1))
const _hoisted_4 = {
  key: 1,
  src: "https://images.unsplash.com/flagged/photo-1563248101-a975e9a18cc6?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=400&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ",
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)))
      }, "Replace!")
    ]),
    _createVNode(_Transition, {
      name: "flip",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (!_ctx.isShowing)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
          : (_openBlock(), _createElementBlock("img", _hoisted_4))
      ]),
      _: 3
    })
  ]))
}